import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { LoginButton, LoginButtonDisabled } from '../../../components/buttons';
import { isValidName, renderTextField } from '../../../components/reduxFields';
import { forgotPasswordAction } from './actions/LoginActions';
// import LoginLogo from '../../../img/loginlogo.png';
// import validate from './validate';
import LogoImageViewer from '../../../components/logoImageViewer'; 

class ForgotPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMessage && this.props.errorMessage !== nextProps.errorMessage) {
      let errorMessage = nextProps.errorMessage;
      this.setState({ errorMessage: errorMessage });
    }
  }

  onSubmit(authData) {
    // authData.ResetPasswordURL = `${window.location.origin}/webadmin/reset-password` ; // Commented this code on 01/23/2022 after pen testing
    // console.log('forgotpassData---', authData);
    this.props.forgotPasswordAction(authData);
  }

  render() {
    const { handleSubmit, authenticatingToken } = this.props;
    if (authenticatingToken) {
      return (
        <div className="login_bg">
          <div className="login-wrapper">
            <div className="login-fields">
            Loading...Please wait !
            </div>
          </div>
        </div>);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <div className="loginlogo">
            <LogoImageViewer isLoginPage={true} logoUrl={null} businessName={null} />
          </div>
          <div className="login-fields">
            <h3>Forgot Password </h3>
            <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              {this.state.errorMessage ?
                <div className="alert-danger">{this.state.errorMessage}</div>
                : '' }
              <div className="row">
                <div className="col-md-12 require">
                  <Field
                    name="userName"
                    type="text"
                    maxLength="60"
                    normalize = {isValidName}
                    label="User name"
                    component={renderTextField} />
                </div>
              </div>
              <div className="pt20">
                {this.props.authenticating ? <LoginButtonDisabled label="Submit" /> : <LoginButton label="Submit" />}
              </div>
              <p className="frgtcont">Please enter username</p>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticating: state.login.authenticating,
    errorMessage: state.login.errorMessage,
  };
}

function validate(values) {
  const error = {};
  if (!values.userName || values.userName.trim() === '') {
    error.userName = 'Please enter user name';
  }
  // if (values.userName) {
  //   if (values.userName.trim().length < 5) {
  //     error.userName = 'Please enter minimum 5 characters';
  //   }
  // }
  return error;
}

ForgotPassword = reduxForm({
  form: 'ForgotPasswordForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(ForgotPassword);

export default connect(mapStateToProps, { forgotPasswordAction })(ForgotPassword);



// WEBPACK FOOTER //
// ./src/modules/Superadmin/logins/forgot_password.js